import { render, staticRenderFns } from "./ModalPrivileges.vue?vue&type=template&id=6bbf4ab8&scoped=true"
import script from "./ModalPrivileges.vue?vue&type=script&lang=js"
export * from "./ModalPrivileges.vue?vue&type=script&lang=js"
import style0 from "./ModalPrivileges.vue?vue&type=style&index=0&id=6bbf4ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf4ab8",
  null
  
)

export default component.exports